<template>
  <div class="bto-sb-widget bto-sb-widget-betslip-checker">
    <div class="bto-sb-widget-title">
      <h3>{{ t("BetSlip.Find") }}</h3>
    </div>
    <div class="bto-sb-widget-content">
      <div class="bto-sb-betslip-checker-input">
        <input
          type="text"
          :placeholder="t('Mobile.betslipcheckerinput')"
          class="bto-sb-form-input"
          v-model="code"
          v-on:keyup.enter="search()" />
      </div>
      <div class="bto-sb-betslip-checker-btn">
        <button type="submit" class="bto-sb-form-btn" @click="search()">
          {{ t("Mobile.BetslipChekerButton") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { searchBetslip, betslipStore, rebet } from '@bto-services/betslip-core';
  import BetslipCheckerService from '@bto-services/api/shared/betslip-checker.request';
  import { EVENT_BUS } from '@bto-services/event-bus';
  import { openModal } from '@bto-services/modal';
  import { BETSLIP_SEARCH_TYPE } from 'bto-models/betslip';

  export default {
    name: 'BetslipCheckerWidget',
    props: {
      openBetInModal: {
        type: Boolean,
        default: true,
        label: 'Open found bet in a popup'
      },
    },
    data() {
      return {
        code: null,
      };
    },
    methods: {
      search() {
        searchBetslip(this.code).then((res) => {
          switch (res.type) {
            case BETSLIP_SEARCH_TYPE.BOOK:
              this.bookBet(res.data);
              return;
            case BETSLIP_SEARCH_TYPE.BET_CHECK:
              this.checkBet(res.data);
              return;
          }
        }).catch(() => {
          openModal({
            title: 'BetSlip.Find',
            message: 'Mobile.invalidcode',
            modalClass: 'bto-sb-modalpopup-sm',
          });
        });
      },
      checkBet(code) {
        const betslipCheckerService = new BetslipCheckerService();
        betslipCheckerService.getParams.Code = code;
        betslipCheckerService.execute(resp => {
          if (!resp.data || resp.data.i.length === 0) {
            openModal({
              title: 'BetSlip.CheckerTitle',
              message: 'Mobile.betslipcheckernoresult',
              modalClass: 'bto-sb-modalpopup-sm',
            });
            return;
          }
          // Open in modal
          if (this.openBetInModal) {
            EVENT_BUS.emit('betslipChecker', resp.data);
            return;
          }
          // Open in separate page
          this.$router.push({ name: 'historyChecker' });
          this.$nextTick(() => {
            EVENT_BUS.emit('betslipCheckerData', resp.data);
          });
        });
      },
      bookBet(rawBetslip) {
        const hasItems = Object.keys(betslipStore.items).length > 0;
        const parsedBetslip = JSON.parse(rawBetslip);
        if (hasItems) {
          openModal({
            title: 'Mobile.BookBetSlip',
            message: 'M.RebetDescription',
            footerCb: () => { this.rebetBooked(parsedBetslip); },
            footerBtnLabel: 'M.Overwrite',
            modalClass: 'bto-sb-modalpopup-sm',
          })
          return;
        }
        // else just load the booked code inside
        if (APP_SETTINGS.betslip_v2.floatingBetslip) {
          document.body.classList.add('bto-sb-betslip-fixed-open');
        }
        this.rebetBooked(parsedBetslip);
      },
      rebetBooked(betslipStore) {
        if (APP_SETTINGS.betslip_v2.floatingBetslip) {
          document.body.classList.add('bto-sb-betslip-fixed-open');
        }
        rebet(betslipStore, this.code);
      }
    },
  };
</script>
